"use strict";

angular.module("contartemx.inicio.poliza", [
	"contartemx",
	"ngTable",
	"ui.router",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader"
])

.controller("PolizaCtrl", function PolizasController($scope, $state, $filter, NgTableParams, callToWebService, mostrarNotificacion, $uibModal, dateTools, ServicioBusqueda) {
	$scope.estadoCte = "Activas";
	$scope.selectedOpt = 0;
	$scope.noHayPolizas = false;

	$scope.FiltroBusqueda = {
	    detalle: ServicioBusqueda.InicioPolizas.get("Detalle"),
	    fDesde : dateTools.getDateStringFromWCF(ServicioBusqueda.InicioPolizas.get("FechaInicial")),
        fHasta : dateTools.getDateStringFromWCF(ServicioBusqueda.InicioPolizas.get("FechaFinal"))
	};

	$scope.toNew = function () {
		$state.transitionTo('inicio.poliza.nueva');
	};

	$scope.seleccionarEstadoProveedor = function (i) {
        $scope.selectedOpt = i;
        switch (i) {
            case 0:
                $scope.estadoCte = "Activas";
                ServicioBusqueda.InicioPolizas.set( {SoloCanceladas:false});
                break;
            case 1:
                $scope.estadoCte = "Canceladas";
                ServicioBusqueda.InicioPolizas.set({ SoloCanceladas: true });
                break;
        }
        ObtenerListadoPolizas();

	};

	$scope.seleccionarEstadoProveedor(ServicioBusqueda.InicioPolizas.get("SoloCanceladas") ? 1 : 0);

    $scope.select = function (index) {
        $scope.selectedRow = index;   
        $scope.mostrarAcciones = true;
    };

    $scope.deselect = function () {
        $scope.selectedRow = -1;
        $scope.mostrarAcciones = false;
    };

    function ObtenerListadoPolizas() {
        $scope.loading = true;
        callToWebService.postCall('ObtenerListadoPolizas', { filtro: ServicioBusqueda.InicioPolizas.get() },
		function sucess(data) {
		    $scope.Polizas = data.Respuesta.Polizas;
		    $scope.noHayPolizas = ($scope.Polizas.length > 0) ? false : true;
		    $scope.noMoreResults = $scope.Polizas.length < ServicioBusqueda.InicioPolizas.get("CantidadRegistrosSolicitados");
		    $scope.loading = false;
		},
		function error(data) {
		    $scope.loading = false;
		    if ('Mensaje' in data) {
		        mostrarNotificacion.error(data.Mensaje);
		    }
		    else {
		        mostrarNotificacion.error('Ocurrio un error al intentar cargar los datos');
		    }
		});
    }

	$scope.tableParams = new NgTableParams({
		page: 1,
		total: 1,
		count: 15,
		counts: []
	});

    $scope.$watch("tableParams", function (params, paramsOld) {
        if (params != paramsOld) {
            var orderedData = $scope.tableParams.sorting ? $filter('orderBy')($scope.Polizas, $scope.tableParams.orderBy()) : $scope.Polizas;
            if (orderedData) {
                $scope.Polizas = orderedData.slice(($scope.tableParams.page() - 1) * $scope.tableParams.count(), $scope.tableParams.page() * $scope.tableParams.count());
                $scope.Polizas = orderedData;
            }
        }
    }, true);

	$scope.CancelarPoliza = function(i){
		var cve;
		if(i == null){
			cve = $scope.Polizas[$scope.selectedRow].ClavePoliza;
		}
		else
		{	
			cve = $scope.Polizas[i].ClavePoliza;
		}
		callToWebService.postCall('DesactivarPoliza', {clavePoliza: cve},
		function sucess(data){
			mostrarNotificacion.info(data.Mensaje);
			$scope.selectedRow = -1;
			$('#contextmenu').removeClass('open');
			var theads = document.getElementsByTagName('thead');
	        theads[0].style.display = 'table-header-group';
	        $(".actionsHeader--clientes").css("display","none");
	        ObtenerListadoPolizas();
		},
		function error(data){
			if('Mensaje' in data){
				mostrarNotificacion.error(data.Mensaje);
			}
			else{
				mostrarNotificacion.error('Ocurrio un error');
			}
		});
	};

	$scope.ActivarPoliza = function(i){
		var cve;
		if(i == null){
			cve = $scope.Polizas[$scope.selectedRow].ClavePoliza;
		}
		else
		{	
			cve = $scope.Polizas[i].ClavePoliza;
		}
		callToWebService.postCall('ActivarPoliza', {clavePoliza: cve},
		function sucess(data){
			mostrarNotificacion.info(data.Mensaje);
			$scope.selectedRow = -1;
			$('#contextmenu').removeClass('open');
			var theads = document.getElementsByTagName('thead');
	        theads[0].style.display = 'table-header-group';
	        $(".actionsHeader--clientes").css("display","none");
	        ObtenerListadoPolizas();
		},
		function error(data){
			if('Mensaje' in data){
				mostrarNotificacion.error(data.Mensaje);
			}
			else{
				mostrarNotificacion.error('Ocurrio un error');
			}
		});
	};

	$scope.eliminarFiltro = function (opciones) {
	    if (angular.isObject(opciones)) {
	        var actualizarLista = true;

	        switch (opciones.filtro) {
	            case 'Detalle':
	                $scope.FiltroBusqueda.detalle = null;
	                break;
	            case 'Fecha':
	                $scope.FiltroBusqueda.fDesde = null;
	                $scope.FiltroBusqueda.fHasta = null;
	                ServicioBusqueda.InicioPolizas.unset("FechaInicial");
	                ServicioBusqueda.InicioPolizas.unset("FechaFinal");
	                break;
	            default:
	                actualizarLista = false;

	                break;
	        }

	        if (actualizarLista) {
	            ObtenerListadoPolizas();
	        }

	    }
	}

	$scope.onFromDateSelect = function (fromDateString) {
	    $scope.FiltroBusqueda.fDate = $scope.Movil ? dateTools.getTimeForWCF(fromDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(fromDateString, 'DD/MM/YY');
	}

	$scope.onToDateSelect = function (toDateString) {
	    $scope.FiltroBusqueda.tDate = $scope.Movil ? dateTools.getTimeForWCF(toDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(toDateString, 'DD/MM/YY');
	}

	$scope.addSearchCriteria = function (f) {
	    //var nombreCuenta = $scope.nombreCuenta;

	    // Resetear Indice Inicial
	    var fDate;
	    var tDate;
	    var fromDateString = $("#fDate").val();
	    
	    if (fromDateString) {
	        if ($scope.Movil)
	            fDate = dateTools.getTimeForWCF(fromDateString, 'YYYY-MM-DD');
	        else
	            fDate = dateTools.getTimeForWCF(fromDateString, 'DD/MM/YY');
	    }
	    var toDateString = $("#tDate").val();
	    if (toDateString) {
	        if ($scope.Movil)
	            tDate = dateTools.getTimeForWCF(toDateString, 'YYYY-MM-DD');
	        else
	            tDate = dateTools.getTimeForWCF(toDateString, 'DD/MM/YY');
	    }
	    var nombreDetalle = f.detalle.$viewValue;
	
	    if (nombreDetalle) {
            ServicioBusqueda.InicioPolizas.set("Detalle",nombreDetalle)
	    }
	    else {
	        ServicioBusqueda.InicioPolizas.unset("Detalle");
	    }
	    
	    if (fDate && tDate) {
	        ServicioBusqueda.InicioPolizas.set({
	            FechaInicial: fDate,
	            FechaFinal: tDate
	        });
	    }
	    else {
	        ServicioBusqueda.InicioPolizas.unset("FechaInicial");
	        ServicioBusqueda.InicioPolizas.unset("FechaFinal");
	    }

	    ObtenerListadoPolizas();
        
	};

	$scope.showMore = function () {
	    ServicioBusqueda.InicioPolizas.set("CantidadRegistrosSolicitados", ServicioBusqueda.InicioPolizas.get("CantidadRegistrosSolicitados") + 15);
	    ObtenerListadoPolizas();
	}

	$scope.removeSearchCriteria = function () {
	    $scope.FiltroBusqueda = {};
	    ServicioBusqueda.InicioPolizas.reset();
	    ObtenerListadoPolizas();
	};

});
